import axios from "axios";

export const api = axios.create({
  baseURL:
    "https://shielded-waters-05959.herokuapp.com/https://anthorflix.herokuapp.com",
});
